import React, { useEffect } from 'react'
import classes from './blogview.module.css'
import gridClasses from '../../styles/grid.module.css'
import Footer from '../../components/Footer/Footer'
import { AuthenticatedHeader } from '../../components/Header/AuthenticatedHeader'
import { Link } from 'react-router-dom'
import { ReactComponent as TwitterIcon } from '../../assets/icons/twitter.svg'
import { ReactComponent as FacebookIcon } from '../../assets/icons/facebook.svg'
import { ReactComponent as LinkedInIcon } from '../../assets/icons/linkedin.svg'
import { BlogPostCard } from '../../components/Cards/GeneralCard/Card'
import { useDispatch, useSelector } from 'react-redux'
import { blogSelectors } from './blogSlice'
import { blogViewActions, blogViewSelectors } from './blogViewSlice'
import { blogApi, increasePostView } from './blogApi'
import {
    BlogContentLoader,
    BlogTitleLoader,
} from '../../components/loaders/BlogLoader'
import avatar from '../../assets/images/avatar-dark.svg'
import CardLoader from '../../components/loaders/CardLoader'
import { IMG_URL } from '../../api/api'
import { Header } from '../../components/Header/Header'
import { getImageURL } from '../../util/functions'
import moment from 'moment'

const BlogView = ({ match }) => {
    const posts = useSelector(blogSelectors.getPostsState)
    const post = useSelector(blogViewSelectors.getPostState)
    const isFetching = useSelector(blogViewSelectors.getIsFetchingState)
    const relatedPostsFetching = useSelector(
        blogViewSelectors.getRelatedPostsIsFetchingState
    )
    const relatedPosts = useSelector(blogViewSelectors.getRelatedPostsState)

    const dispatch = useDispatch()

    useEffect(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })

        const postId = Number(match.params.postId)

        const post = posts.find(({ postid: id }) => postId === id)
        if (post) {
            dispatch(blogViewActions.getPostsRequestSuccess({ post }))
        } else {
            dispatch(blogApi.getPost(postId))
        }

        dispatch(blogApi.getRelatedPosts(postId))

        dispatch(increasePostView(postId))

        return () => {
            dispatch(blogViewActions.reset())
        }
    }, [match.params.postId])

    const TWITTER_SHARE_URL = `https://twitter.com/intent/tweet?url=${decodeURI(
        window.location.href
    )}`
    const FACEBOOK_SHARE_URL = `https://www.facebook.com/sharer.php?u=${decodeURI(
        window.location.href
    )}`
    const LINKEDIN_SHARE_URL = `https://www.linkedin.com/sharing/share-offsite/?url=${decodeURI(
        window.location.href
    )}`

    const shareLinkProps = {
        target: '_blank',
        rel: 'norefferer noopener',
    }

    return (
        <>
            <div className={classes.topWrapper}>
                <Header className={classes.header} />
                <div className={classes.top}>
                    <Link to={'/blog'} className={classes.topBackLink}>
                        Back to blog
                    </Link>
                    {/*{true ? (*/}
                    {isFetching ? (
                        <BlogTitleLoader />
                    ) : (
                        <>
                            <h1 className={classes.topPostName}>
                                {post.caption}
                            </h1>
                            <div className={classes.postDetails}>
                                <img
                                    src={
                                        post.author.dp
                                            ? getImageURL(post.author.dp)
                                            : avatar
                                    }
                                    alt="Author"
                                    className={classes.postDetailsAuthorImage}
                                />
                                <div>
                                    <p
                                        className={
                                            classes.postDetailsAuthorName
                                        }
                                    >
                                        {`${post.author.firstname} ${post.author.lastname}`}
                                    </p>
                                    {/* <p className={classes.postDetailsDate}>
                                        {moment(post.publisheddate).format(
                                            'MMM DD, YYYY'
                                        )}
                                    </p> */}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <div className={classes.mainContent}>
                <div className={classes.socialMediaLinks}>
                    <a
                        href={TWITTER_SHARE_URL}
                        className={classes.socialMediaLink}
                        {...shareLinkProps}
                    >
                        <TwitterIcon
                            className={classes.socialMediaLinkTwIcon}
                        />
                    </a>
                    <a
                        href={FACEBOOK_SHARE_URL}
                        className={classes.socialMediaLink}
                        {...shareLinkProps}
                    >
                        <FacebookIcon
                            className={classes.socialMediaLinkFbIcon}
                        />
                    </a>
                    <a
                        href={LINKEDIN_SHARE_URL}
                        className={classes.socialMediaLink}
                        {...shareLinkProps}
                    >
                        <LinkedInIcon
                            className={classes.socialMediaLinkLnIcon}
                        />
                    </a>
                </div>
                <div>
                    {isFetching ? (
                        <BlogContentLoader />
                    ) : (
                        <>
                            <img
                                src={post.thumbnail}
                                alt="Post Display Image"
                                className={classes.postImage}
                            />
                            <div
                                className={classes.postText}
                                dangerouslySetInnerHTML={{
                                    __html: post.content,
                                }}
                            />
                        </>
                    )}
                </div>
            </div>
            <section className={gridClasses.container}>
                <h3 className={classes.relatedStoriesHeader}>
                    Related Stories
                </h3>
                <div className={classes.relatedStoriesGrid}>
                    {relatedPostsFetching ? (
                        <>
                            <CardLoader />
                            <CardLoader />
                            <CardLoader />
                        </>
                    ) : relatedPosts.length > 0 ? (
                        relatedPosts.map(
                            ({
                                postid,
                                caption,
                                publisheddate,
                                thumbnail,
                                author,
                            }) => (
                                <BlogPostCard
                                    title={caption}
                                    author={`${author.firstname} ${author.lastname}`}
                                    authorImage={author.dp}
                                    date={publisheddate}
                                    imageUrl={thumbnail}
                                    key={postid}
                                    className={classes.story}
                                    postId={postid}
                                />
                            )
                        )
                    ) : (
                        <h4 className={classes.relatedStoriesEmpty}>
                            No Related Stories Found
                        </h4>
                    )}
                </div>
            </section>
            <Footer />
        </>
    )
}

export default BlogView
